/**
 * схема для сайдбара
 * @property {array} sidebarItems - элементы сайдбара
 */
let schemeSidebar = {
    sidebarItems: [
        {
            name: 'Рабочий стол',
            route: '/analytics',
            iconClass: 'fa fa-desktop',
            icon: require("../assets/svg/dashboard.svg")
        },
        {
            name: 'Импорт',
            route: '/import',
            iconClass: 'fa fa-upload',
            icon: require("../assets/svg/clipboard.svg")
        },
        {
            name: 'Настройки',
            route: '/settings',
            iconClass: 'fa fa-cog',
            icon: require("../assets/svg/settings.svg")
        }
    ]
};

export default schemeSidebar;